/**
 * Where people write to Kantera, and where Kantera copies mail (KAN-208). The API, the web app and
 * the mobile app all take these from here, so the three cannot drift apart again.
 *
 * kantera.dev is Kantera's domain; its mail arrives through Cloudflare Email Routing. The apps
 * used to name two other domains: the .com, which belongs to someone else (an unrelated site with
 * its own mail), so a family's deletion request, which can name a child, went to a stranger's
 * inbox; and the .app, which has no MX record, so the compliance copy of every consent and
 * erasure email reached nobody. apps/api/src/__tests__/contact-addresses.test.ts keeps both out.
 *
 * Sender addresses (noreply@…, POSTMARK_FROM_EMAIL) are not here. They are configuration
 * (packages/config), and moving the sending domain needs Postmark setup of its own.
 *
 * This lives in @kantera/types, not @kantera/config, because all three apps import this package
 * at runtime. The mobile app does not import @kantera/config, which reads import.meta.env.
 */
export const KANTERA_EMAIL = {
    /** Families' privacy requests: data export, deletion, consent questions. */
    privacy: 'privacy@kantera.dev',
    /** General help for clubs and families. */
    support: 'support@kantera.dev',
    /** The blind copy on every COPPA consent and erasure email: the compliance audit trail. */
    compliance: 'compliance@kantera.dev',
    /** Security reports and the first call in a breach (security/breach-notification.ts). */
    security: 'security@kantera.dev',
    /** Legal sign-off before any external breach notice. */
    legal: 'legal@kantera.dev',
    /** Breach escalation when minors or more than 10 users are affected. */
    cto: 'cto@kantera.dev',
};
/**
 * Kantera's published privacy policy: apps/web/public/privacy-policy.html, which Cloudflare Pages
 * serves at /privacy-policy (it redirects the .html path there). The mobile app opens this.
 */
export const KANTERA_PRIVACY_POLICY_URL = 'https://kantera.dev/privacy-policy';
//# sourceMappingURL=contact.js.map